export enum clientOrderManagementTableViewColumnLabel {
  ClientName = 'Client Name',
  clientCode = 'Client Code',
  country = 'Country',
  doors = 'Doors',
  stores = 'Stores',
  shipTo = 'Ship To',
  creationDate = 'Date',
  order = 'Order #',
  zam = 'ZAM',
  salesAsst = 'Sales Asst.',
  qty = 'Qty',
  value = 'Value',
  globalValue = 'Value EUR',
  activityGender = 'Activity Gender',
  status = 'Status',
  deliveryDate = 'Delivery Date',
  actions = 'Actions',
  sapStatus = 'SAP Status',
  sapOrderNumber = 'SAP Order #',
  zoneName = 'Zone Name',
  zoneCode = 'Zone Code'
}
